// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Single-row pagination footer used under every paged table. */
.tbl-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 10px 16px;
  border-top: 1px solid var(--n-200);
  background: var(--n-50);
  font-size: 13px;
  color: var(--n-600);
}

.tbl-pagination-count {
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 500;
}
.tbl-pagination-count strong {
  color: var(--n-900);
  font-weight: 700;
}

.tbl-pagination-size {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
}
.tbl-pagination-size label {
  color: var(--n-600);
  font-weight: 500;
}
.tbl-pagination-size select {
  padding: 4px 8px;
  border: 1px solid var(--n-300);
  border-radius: var(--radius-md);
  background: var(--n-0);
  font-size: 12px;
  color: var(--n-900);
  cursor: pointer;
}

.tbl-pagination-nav {
  display: flex;
  align-items: center;
  gap: 4px;
}

.tbl-pgbtn {
  min-width: 32px;
  height: 32px;
  padding: 0 10px;
  border: 1px solid var(--n-200);
  background: var(--n-0);
  color: var(--n-600);
  border-radius: var(--radius-md);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--dur-base) ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.tbl-pgbtn:hover:not(:disabled):not(.is-active):not(.tbl-pgbtn-ellipsis) {
  background: var(--n-100);
  border-color: var(--n-300);
  color: var(--n-900);
}
.tbl-pgbtn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.tbl-pgbtn.is-active {
  background: var(--clr-accent);
  border-color: var(--clr-accent);
  color: var(--n-0);
}
.tbl-pgbtn-ellipsis {
  border: none;
  background: transparent;
  cursor: default;
  pointer-events: none;
  color: var(--n-400);
}

/* Mobile / narrow — wrap into 2 lines neatly */
@media (max-width: 640px) {
  .tbl-pagination { flex-direction: column; align-items: stretch; gap: 8px; }
  .tbl-pagination-nav { justify-content: center; }
  .tbl-pagination-count, .tbl-pagination-size { justify-content: center; }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/common/TablePagination.css"],"names":[],"mappings":"AAAA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;EAC/B,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB,sBAAsB,EAAE,oBAAoB,EAAE,QAAQ,EAAE;EAC1E,sBAAsB,uBAAuB,EAAE;EAC/C,8CAA8C,uBAAuB,EAAE;AACzE","sourcesContent":["/* Single-row pagination footer used under every paged table. */\n.tbl-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n  padding: 10px 16px;\n  border-top: 1px solid var(--n-200);\n  background: var(--n-50);\n  font-size: 13px;\n  color: var(--n-600);\n}\n\n.tbl-pagination-count {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-weight: 500;\n}\n.tbl-pagination-count strong {\n  color: var(--n-900);\n  font-weight: 700;\n}\n\n.tbl-pagination-size {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n}\n.tbl-pagination-size label {\n  color: var(--n-600);\n  font-weight: 500;\n}\n.tbl-pagination-size select {\n  padding: 4px 8px;\n  border: 1px solid var(--n-300);\n  border-radius: var(--radius-md);\n  background: var(--n-0);\n  font-size: 12px;\n  color: var(--n-900);\n  cursor: pointer;\n}\n\n.tbl-pagination-nav {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.tbl-pgbtn {\n  min-width: 32px;\n  height: 32px;\n  padding: 0 10px;\n  border: 1px solid var(--n-200);\n  background: var(--n-0);\n  color: var(--n-600);\n  border-radius: var(--radius-md);\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--dur-base) ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.tbl-pgbtn:hover:not(:disabled):not(.is-active):not(.tbl-pgbtn-ellipsis) {\n  background: var(--n-100);\n  border-color: var(--n-300);\n  color: var(--n-900);\n}\n.tbl-pgbtn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n.tbl-pgbtn.is-active {\n  background: var(--clr-accent);\n  border-color: var(--clr-accent);\n  color: var(--n-0);\n}\n.tbl-pgbtn-ellipsis {\n  border: none;\n  background: transparent;\n  cursor: default;\n  pointer-events: none;\n  color: var(--n-400);\n}\n\n/* Mobile / narrow — wrap into 2 lines neatly */\n@media (max-width: 640px) {\n  .tbl-pagination { flex-direction: column; align-items: stretch; gap: 8px; }\n  .tbl-pagination-nav { justify-content: center; }\n  .tbl-pagination-count, .tbl-pagination-size { justify-content: center; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
